module.exports = __webpack_public_path__ + "img/dynamic_yujing.9fe11ce2.png";